import React from "react";
import PrizeLabelStatus from "./prizeLabelStatus";

const PrizesCard = ({ prize }: { prize: SubscriptionCompetitionDetailsPrize }) => {
  return (
    <div
      className={
        "w-full min-h-[169px] lg:min-h-[216px] relative flex flex-col gap-2 lg:gap-3 rounded bg-white max-lg:shadow-[0_1.5px_8px_0_rgba(0,0,0,0.20)] lg:bg-[#F5F5F5] lg:rounded-[5px] pt-4 pb-3 px-2 lg:pt-5 lg:pb-4 lg:px-2.5"
      }>
      <PrizeLabelStatus label="TO BE WON" className={"absolute left-0 top-0"} />

      <div className={"w-full lg:px-2"}>
        <img src={prize.imageUrl} alt={"prize-image"} width={180} height={110} className="w-full aspect-[180/110]" />
      </div>

      <div className={"grow w-full flex flex-col gap-1 lg:gap-[5px]"}>
        <div
          className={
            "w-full truncate text-[#696971] text-center font-jost text-base font-bold leading-[22px] lg:text-xl lg:leading-[26px]"
          }>
          {prize.title}
        </div>
        <div
          className={
            "w-full truncate text-[#A2A2A2] text-center font-jost text-xs font-normal leading-4 lg:text-base lg:leading-[22px]"
          }>
          {prize.description}
        </div>
      </div>
    </div>
  );
};

export default PrizesCard;
